/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function ApiPair(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                viewBox='0 0 28.84 26.29'
                xmlns='http://www.w3.org/2000/svg'
            >
                <title>API</title>
                <g
                    data-name='Layer 2'
                    id='Layer_2'
                >
                    <g
                        data-name='Layer 1'
                        fill={iconColor || '#000'}
                        id='Layer_1-2'
                    >
                        <path d='M28.84,13a6.47,6.47,0,0,0-4-5.85l-.09,0V7c0-.16,0-.32,0-.48C24.75,2.94,21.46,0,17.41,0a7.65,7.65,0,0,0-5.72,2.46l-.07.08-.1,0A5.26,5.26,0,0,0,9.23,2a4.59,4.59,0,0,0-4.82,4.3,3.08,3.08,0,0,0,0,.61l0,.12L4.37,7A6.59,6.59,0,0,0,0,13c0,3.48,3,6.32,6.88,6.54v-1A5.84,5.84,0,0,1,1.14,13,5.65,5.65,0,0,1,5.21,7.81l.6-.2-.15-.54a2.8,2.8,0,0,1-.11-.8A3.52,3.52,0,0,1,9.23,3a3.92,3.92,0,0,1,2.07.58l.61.37.41-.53A6.42,6.42,0,0,1,17.41,1c3.42,0,6.2,2.5,6.2,5.57a4.66,4.66,0,0,1-.06.72l-.07.46.5.2A5.57,5.57,0,0,1,27.7,13a5.86,5.86,0,0,1-5.55,5.53v1C25.91,19.27,28.84,16.43,28.84,13Z' />
                        <path d='M19.62,21h0a.88.88,0,0,0-.37-.37,1.48,1.48,0,0,0-.78-.14h-.71V9.22a.51.51,0,1,0-1,0V20.48H16a1.4,1.4,0,0,0-.77.14.82.82,0,0,0-.38.38,1.42,1.42,0,0,0-.14.77V25a1.55,1.55,0,0,0,.13.77,1,1,0,0,0,.38.38,1.59,1.59,0,0,0,.78.13h2.43a1.53,1.53,0,0,0,.77-.13.93.93,0,0,0,.38-.38,1.44,1.44,0,0,0,.14-.77V21.77A1.42,1.42,0,0,0,19.62,21Zm-1.15,4.23h-2.7a1.44,1.44,0,0,1,0-.28V21.77c0-.19,0-.26,0-.27h3s0,.11,0,.27V25c0,.18,0,.25,0,.26Z' />
                        <path d='M13.57,8.84a1.42,1.42,0,0,0-.77-.14H10.36a1.44,1.44,0,0,0-.77.14.93.93,0,0,0-.38.38,1.51,1.51,0,0,0-.13.76v3.19a1.42,1.42,0,0,0,.14.77.9.9,0,0,0,.37.38,1.55,1.55,0,0,0,.77.13h.72V25.78a.5.5,0,0,0,.5.51.51.51,0,0,0,.51-.51V14.45h.71a1.53,1.53,0,0,0,.77-.13,1,1,0,0,0,.38-.38,1.53,1.53,0,0,0,.13-.77V10A1.48,1.48,0,0,0,14,9.22.87.87,0,0,0,13.57,8.84Zm-.77,4.61H10.36a.92.92,0,0,0-.26,0,1.12,1.12,0,0,1,0-.29V10a1.58,1.58,0,0,0,0-.26,1,1,0,0,1,.28,0H12.8a1.83,1.83,0,0,0,.27,0s0,.09,0,.28v3.19c0,.2,0,.27,0,.27Z' />
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}